import React, { useState } from 'react';
import { Box, Typography, Button } from '@mui/material';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import ApiKeyDialog from '../../../Organization/ApiKey/ApiKeyDialog';

function ApiInstructions({ isTest = false }) {
  const [apiKeyDialogOpen, setApiKeyDialogOpen] = useState(false);

  const handleManageApiKeys = () => {
    setApiKeyDialogOpen(true);
  };

  const handleCloseApiKeyDialog = () => {
    setApiKeyDialogOpen(false);
  };

  return (
    <Box>
      <Typography variant="body2" color="text.secondary" mb={2}>
        Use the cURL command above to trigger this workflow {isTest ? 'test ' : ''}via API
      </Typography>

      <Box>
        <Typography variant="body2" color="text.primary" mb={1}>
          • Replace{' '}
          <Box
            component="span"
            sx={{
              fontFamily: 'monospace',
              bgcolor: 'action.hover',
              px: 0.5,
              py: 0.25,
              borderRadius: 0.5,
              fontSize: '0.9em',
              color: 'text.primary',
            }}
          >
            YOUR_API_TOKEN
          </Box>{' '}
          with your actual API key
        </Typography>

        <Typography variant="body2" color="text.primary" mb={1}>
          • Update placeholder values in the JSON payload as needed
        </Typography>

        <Typography variant="body2" color="text.primary" mb={1}>
          • Execute the command in your terminal or integrate it into your application
        </Typography>

        <Typography variant="body2" color="text.primary" mb={2}>
          • The API will return a {isTest ? 'test ' : ''}session ID for tracking workflow execution
        </Typography>

        <Button
          variant="outlined"
          size="small"
          onClick={handleManageApiKeys}
          startIcon={<VpnKeyIcon />}
          sx={{ mt: 1 }}
        >
          Get API Key
        </Button>
      </Box>

      <ApiKeyDialog open={apiKeyDialogOpen} onClose={handleCloseApiKeyDialog} />
    </Box>
  );
}

export default ApiInstructions;
